export default __webpack_public_path__ + "static/lean-web-banner-0f3f938cc7be09e7b10a4cfd1c91d9a5.png";